export default {
      id: "oc-menu-monitor-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-menu-monitor",
      toString: function () {
        return this.url;
      }
    }